import {
  Box,
  Button,
  Card,
  Checkbox,
  CrudMode,
  DataArray,
  DataDisplay,
  formatBoolean,
  GeneralValidationErrors,
  Grid,
  GridBreak,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import {
  Permission,
  PermissionAction,
  School,
  StudentServiceSubType,
  StudentServiceSubTypeEditResource,
  StudentServiceSubTypeViewResource,
  StudentServiceType,
  StudentServiceTypeEditResource,
  StudentServiceTypeViewResource,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import { ServiceSubType } from "./ServiceSubType";
import ApiService from "services/apiService";
import { isAuthorized } from "services";
import { initDataModel } from "utils";

export const ServiceSubTypes = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  serviceSubTypes: StudentServiceSubType[];
  setServiceSubTypes: (value: StudentServiceSubType[]) => void;
  validationErrors: ValidationErrors | string[];
  generalValidationErrors: ValidationErrors | string[];
  onEdit: () => void;
}) => {
  const [viewResource, setViewResource] = useState<StudentServiceSubTypeViewResource>({});
  const [editResource, setEditResource] = useState<StudentServiceSubTypeEditResource>({});

  useEffect(() => {
    ApiService.studentServiceSubTypes.getViewResource().then((response) => setViewResource(response));
    ApiService.studentServiceSubTypes.getEditResource().then((response) => setEditResource(response));
  }, []);

  return (
    <Stack spacing="md">
      <Stack direction="row" alignItems="center" justifyContent={"space-between"}>
        <Stack>
          <Typography variant="h6" fontWeight={(theme) => theme.typography.fontWeightRegular}>
            Sub-types
          </Typography>
          <Stack>
            <GeneralValidationErrors errors={props.generalValidationErrors} />
          </Stack>
        </Stack>

        {isAuthorized(props.rootPermission, PermissionAction.Create) && (
          <Button
            onClick={() =>
              props.setServiceSubTypes(
                produce(props.serviceSubTypes, (draft) => {
                  draft.unshift(initDataModel<StudentServiceSubType>({}));
                  props.onEdit();
                })
              )
            }
            variant="outlined"
          >
            + New
          </Button>
        )}
      </Stack>

      {props.serviceSubTypes.map((serviceSubType, index) => (
        <ServiceSubType
          rootPermission={props.rootPermission}
          serviceSubType={serviceSubType}
          setServiceSubType={(value) => {
            props.setServiceSubTypes(
              produce(props.serviceSubTypes, (draft) => {
                draft[index] = value;
              })
            );
            props.onEdit();
          }}
          cancelCreate={() =>
            props.setServiceSubTypes(
              produce(props.serviceSubTypes, (draft) => {
                draft.splice(index, 1);
              })
            )
          }
          viewResource={viewResource}
          editResource={editResource}
          validationErrors={props.validationErrors[index] || []}
        />
      ))}

      {props.serviceSubTypes.length === 0 && (
        <Card>
          <Typography>No Sub-types</Typography>
        </Card>
      )}
    </Stack>
  );
};
